import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import FullScreenOverlay from '../FullScreenOverlay/FullScreenOverlay';
import './EditMeal.css'
import { FaPlus } from "react-icons/fa6";
import { get, post } from '../../Services/api';
import upload_image_firebase_storage from "../../Utility/upload_image_firebase_storage";
import { useLocation } from 'react-router-dom';
import yyyy_mm_dd_date_format from "../../Utility/yyyy_mm_dd_date_format";
import loading_display from "../../Utility/loading_display";
import { useAuth } from "../AuthContext/AuthContext";

function EditMealModal({ setEditMeal }) {
    const { currentUser } = useAuth();

    const [underParentMeal, setUnderParentMeal] = useState(false)
    const [privateMeal, setPrivateMeal] = useState(false)
    const [mealName, setMealName] = useState('')
    const [description, setDescription] = useState('')
    const [timeToMake, setTimeToMake] = useState()
    const [timeToMakeUnit, setTimeToMakeUnit] = useState('mins')
    const [servingSize, setServingSize] = useState()
    // Ingred
    const [ingredientSuggestion, setIngredientSuggestion] = useState([])
    const [ingredientSearchIndex, setIngredientSearchIndex] = useState()
    const [ingredients, setIngredients] = useState([''])
    const [numIngredients, setNumIngredients] = useState(0)
    // Recipe
    const [recipes, setRecipes] = useState([''])
    // Course & Cuisine
    const [allCourses, setAllCourses] = useState([])
    const [course, setCourse] = useState('')
    const [allCuisines, setAllCuisines] = useState([])
    const [cuisine, setCuisine] = useState('')

    const [total_calories, setTotal_calories] = useState(0)
    const [img, setImg] = useState()
    const [modalOpen, setModalOpen] = useState()

    const suggestionDivRefs = useRef([]);  // Store refs for each suggestion div

    const [meal_id, setMeal_id] = useState()

    const location = useLocation();
    const navigate = useNavigate();


    useEffect(() => {
        // Function to extract the edit_meal_id query param
        const params = new URLSearchParams(window.location.search);
        const mealId = params.get('edit_meal_id');

        // Set the state with the current meal ID
        setMeal_id(mealId);
    }, [location.search]);


    useEffect(() => {
        // Initiate all values
        constructor()
    }, [meal_id])


    async function constructor() {
        try {
            // Ingredient unit
            const result = await get("/api/meal/get-meal-detail?meal_id=" + meal_id + "&user_id=" + currentUser.uid);
            if (result.parent_meal_id)
                setUnderParentMeal(true)
            setMealName(result.name)
            setDescription(result.description)
            setImg(result.image)
            setTimeToMake(result.time_to_make)
            setCuisine(result.cuisines[0])
            setCourse(result.courses[0])
            const sortedDescriptions = result.recipe.sort((a, b) => a.order_num - b.order_num).map(step => step.description);
            setRecipes(sortedDescriptions)
            setPrivateMeal(result.user_create_id ? true : false)
            setServingSize(result.serving_size)

            const ingredients_arr = []
            for (let i = 0; i < result.ingredient.length; i++) {
                const ingredient = result.ingredient[i]
                const result_ing = await get("/api/ingredients/search-ingredients-name?name=" + ingredient.name)
                result_ing?.map((res, j) => {
                    if (res.name == ingredient.name) {
                        const units = []
                        res?.units?.map((unit, i) => {
                            if (unit.ingredient_id == ingredient.ingredient_id)
                                units.push({ ...unit, selected: true })
                            else
                                units.push(unit)
                        })
                        ingredients_arr.push({ name: ingredient.name, units: units, amount: ingredient.amount })
                    }
                })
            }
            setIngredients(ingredients_arr)

            //calculate_calories
            calculate_calories(ingredients_arr)

            //countIngredients
            countIngredients(ingredients_arr)

            // All cuisines
            const result_cu = await get("/api/meal/get-all-cuisines")
            setAllCuisines(result_cu)

            // All courses
            const result_co = await get("/api/meal/get-all-courses")
            setAllCourses(result_co)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }


    // Calculate calories helper
    async function calculate_calories(tmp) {
        const result_ing = []
        tmp?.map((ing, j) => {
            ing?.units?.map((unit, k) => {
                if (unit.selected)
                    result_ing.push({ id: unit.ingredient_id, amount: ing.amount })
            })
        })

        const queryString = encodeURIComponent(JSON.stringify(result_ing));
        const calories = await get('/api/ingredients/calculate-ingredients-calories?ingredients=' + queryString)
        setTotal_calories(calories.total_calories)
    }

    /* MEAL */

    // On input change
    function ingredientFunc(value, i) {
        // Get ingredient suggestion from db
        getIngredient(value, i)
        // set input value
        const tmp = [...ingredients];
        tmp[i] = value
        setIngredients(tmp)
    }



    /* INGREDIENT */

    // Ingredient suggestion
    async function getIngredient(value, i) {
        if (value) {
            try {
                const result = await get("/api/ingredients/search-ingredients-name?name=" + value)
                if (result && result.length) {
                    result.sort((a, b) => {
                        if (a.name < b.name) {
                            return -1;
                        }
                        if (a.name > b.name) {
                            return 1;
                        }
                        return 0;
                    });

                    setIngredientSuggestion(result)
                    setIngredientSearchIndex(i)
                } else
                    setIngredientSuggestion([])
            } catch (error) {
                console.error('Error fetching data:', error);
                setIngredientSuggestion([])
            }
        } else
            setIngredientSuggestion([])
    }
    // On input change
    function ingredientFunc(value, i) {
        // Get ingredient suggestion from db
        getIngredient(value, i)
        // set input value
        const tmp = [...ingredients];
        tmp[i] = value
        setIngredients(tmp)
    }
    // ingredient suggestion selected
    function ingredSuggestionClicked(value, i) {
        // Ingredient
        const tmp_i = [...ingredients];
        const units = []
        value.units.map((unit, i) => {
            if (i == 0)
                units.push({ ...unit, selected: true })
            else
                units.push(unit)
        })
        tmp_i[i] = { name: value.name, units: units }
        setIngredients(tmp_i)

        setIngredientSuggestion([])
    }
    // new suggestion
    function addNewIngredient() {
        // Ingred
        const tmp_i = [...ingredients];
        tmp_i.push('')
        setIngredients(tmp_i)
    }
    // On input amount change
    async function ingredAmountFunc(value, i) {
        const tmp = [...ingredients];
        let amount = Math.round(parseFloat(value) * 100) / 100
        if (amount <= 0)
            amount = 0
        else if (amount > 999)
            amount = 999
        tmp[i] = { ...ingredients[i], amount: amount }
        setIngredients(tmp)

        // calculate calories
        calculate_calories(tmp)

        // update num ingredients
        countIngredients(tmp)
    }

    // On select unit
    function unitSelected(value, i) {
        const tmp = [...ingredients];
        const units = []
        ingredients[i].units.map((unit, j) => {
            if (unit.ingredient_id == value)
                units.push({ ...unit, selected: true })
            else
                units.push({ ...unit, selected: false })
        })
        tmp[i] = {
            ...ingredients[i],
            units: units
        }
        setIngredients(tmp)
    }
    // drop index of recipe
    function deleteIngredient(i) {
        // Ingred
        const tmp = []
        ingredients.map((ing, j) => {
            if (j != i)
                tmp.push(ing)
        })
        setIngredients(tmp)

        // calculate_calories
        calculate_calories(tmp)

        // update num ingredients
        countIngredients(tmp)
    }


    /* RECIPE */

    // On input change
    function recipeFunc(value, i) {
        // set input value
        const tmp = [...recipes];
        tmp[i] = value
        setRecipes(tmp)
    }
    // new recipe
    function addNewRecipe() {
        const tmp = [...recipes];
        tmp.push('')
        setRecipes(tmp)
    }
    // drop index of recipe
    function deleteRecipe(i) {
        const tmp = [...recipes]
        tmp.splice(i, 1);
        setRecipes(tmp)
    }

    const handleSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission behavior
        loading_display(true)

        // set all ingredients object
        const ingred_tmp = []
        ingredients.map((ingred, i) => {
            if (ingred) {
                ingred.units.map((unit, k) => {
                    // select ingredient that has been selected
                    if (unit.selected)
                        ingred_tmp.push({
                            id: unit.ingredient_id,
                            amount: ingred.amount ? ingred.amount : 0,
                        })
                })
            }
        })
        // remove unused recipe elemnts
        const recipe_tmp = []
        recipes.map((recipe, i) => {
            if (recipe)
                recipe_tmp.push(recipe)
        })
        // image
        let img_url = img
        if (typeof img != 'string')
            img_url = await upload_image_firebase_storage({ path: '/Meal Images', imageFile: img })
        // add data to meal
        const meal_data = {
            meal_name: mealName,
            meal_description: description,
            time_to_make: timeToMake,
            time_to_make_unit: timeToMakeUnit,
            ingredients: ingred_tmp,
            recipes: recipe_tmp,
            cuisine_id: cuisine,
            course_id: course,
            img: img_url,
            under_parent_meal: underParentMeal,
            private_meal: privateMeal,
            serving_size: servingSize
        }

        try {
            const result = await post("/api/meal/user-edit-meal", {
                meal_data: meal_data,
                uid: currentUser.uid,
                meal_id: meal_id,
                today_date: yyyy_mm_dd_date_format({})
            })
            if (result) {
                const currentUrl = window.location.href;
                if (currentUrl.includes("meal-details")) {
                    // Redirect to the new URL with the specified newId
                    navigate(`/meal-details/${result.data}`);
                }
                window.location.reload();
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }

        loading_display(false)
    };


    const fileInputRef = useRef(null);

    const handleDivClick = () => {
        // Trigger the hidden file input click
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            setImg(file)
        }
    };

    useEffect(() => {
        if (modalOpen === false) {
            // on parent
            setEditMeal(false)
            // this modal
            setModalOpen()
        }
    }, [modalOpen])


    useEffect(() => {
        const handleClickOutside = (event) => {
            let clickedOutside = true;

            // Loop through suggestion div refs and check if the click was outside
            suggestionDivRefs.current.forEach((ref, index) => {
                if (ref && ref.contains(event.target)) {
                    clickedOutside = false;  // Click happened inside a suggestion div
                }
            });

            if (clickedOutside) {
                setIngredientSuggestion([]);  // Clear suggestions
            }
        };


        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    function countIngredients(ingredients) {
        let count = 0
        ingredients.map((ing, i) => {
            if (ing.name && ing.amount)
                count++
        })
        setNumIngredients(count)
    }

    function changePrepTime(value) {
        let time = timeToMakeUnit == 'hrs' ? Math.round(parseFloat(value) * 10) / 10 : parseInt(value)
        if (time <= 0)
            time = 0
        else if (time > 999)
            time = 999
        setTimeToMake(time)
    }

    return (
        <div>
            <FullScreenOverlay modalOpen={modalOpen} setModalOpen={setModalOpen}>
                <div className="create_meal_modal_div gray_scale_2">
                    <form onSubmit={handleSubmit}>
                        <div className="create_meal_modal_action_buttons flex gap_6">
                            <p className="create_meal_modal_action_cancel font_weight_600 cursor_pointer" onClick={() => setModalOpen(false)}>Cancel</p>
                            <button type="submit" className=" create_meal_modal_action_create_meal green_gradient white font_weight_600 cursor_pointer font_size_14">Save Changes</button>
                        </div>
                        <div className="flex flex_column gap_40">
                            <div className="create_meal_modal_general_detail">
                                <div className="create_meal_modal_left_right_div flex flex_column gap_16 ">
                                    <div>
                                        <p>Meal Name*</p>
                                        <input className="create_meal_modal_meal_name gray_scale_2" placeholder="Name of meal..." value={mealName} onChange={(e) => setMealName(e.target.value)} required />
                                    </div>

                                    <div>
                                        <p>Description</p>
                                        <textarea className="create_meal_modal_meal_description font_family_inter gray_scale_2" type="text" placeholder="Description of meal..." value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
                                    </div>

                                    <div className="create_meal_modal_minor_details">
                                        <div>
                                            <p>Cuisine*</p>
                                            <select required className="create_meal_modal_meal_unit gray_scale_2 cursor_pointer" onChange={(e) => setCuisine(e.target.value)}>
                                                <option value={''}>---</option>
                                                {allCuisines.map((cuis, i) => (
                                                    <option key={i} value={cuis.cuisine_id} selected={cuisine === cuis.cuisine_id}>{cuis.name}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <p>Prep Time*</p>
                                            <div className="create_meal_modal_prep_time_div">
                                                <input required className="create_meal_modal_prep_time_input gray_scale_2" value={timeToMake} onChange={(e) => changePrepTime(e.target.value)} type='number' />
                                                <select onChange={(e) => setTimeToMakeUnit(e.target.value)} className="create_meal_modal_prep_time_select gray_scale_2 cursor_pointer">
                                                    <option>mins</option>
                                                    <option>hrs</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div>
                                            <p>Course*</p>
                                            <select required className="create_meal_modal_meal_unit gray_scale_2 cursor_pointer" onChange={(e) => setCourse(e.target.value)}>
                                                <option value={''}>---</option>
                                                {allCourses.map((cour, i) => (
                                                    <option key={i} value={cour.course_id} selected={course === cour.course_id}>{cour.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="create_meal_modal_course_cousine">
                                        <div>
                                            <p>Ingredients</p>
                                            <p className="create_meal_modal_meal_name">{numIngredients}</p>
                                        </div>

                                        <div>
                                            <p>Calories</p>
                                            <p className="create_meal_modal_meal_name">{parseInt(total_calories) ? parseInt(total_calories) : 0}</p>
                                        </div>

                                        <div>
                                            <p>Serving Size</p>
                                            <input className="create_meal_modal_meal_name" step="any"
                                                value={servingSize} required
                                                min={0} onChange={(e) => setServingSize(e.target.value)} type='number' />
                                        </div>
                                    </div>
                                </div>

                                <div className="create_meal_modal_left_right_div create_meal_modal_image_div flex align_center justify_center cursor_pointer" onClick={handleDivClick}>
                                    {img ?
                                        <img className="create_meal_modal_img" src={typeof img === "string" ? img : URL.createObjectURL(img)} />
                                        : <div className="flex flex_column gap_20 align_center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="51" height="50" viewBox="0 0 51 50" fill="none">
                                                <path d="M50.6254 36.125C50.3431 39.8794 48.6593 43.3903 45.9083 45.9607C43.1573 48.5311 39.5402 49.9729 35.7754 50H15.0254C12.3949 49.9973 9.81144 49.3029 7.53409 47.9865C5.25673 46.6702 3.36559 44.778 2.05037 42.5L11.2254 35C12.3411 34.0868 13.7442 33.5984 15.1857 33.6212C16.6273 33.6441 18.0142 34.1769 19.1004 35.125C19.829 35.8016 20.6849 36.3266 21.6183 36.6694C22.5517 37.0122 23.5439 37.166 24.5373 37.1218C25.5306 37.0776 26.5053 36.8363 27.4046 36.4119C28.3038 35.9876 29.1097 35.3887 29.7754 34.65L34.7754 29.2C35.3284 28.5928 35.9993 28.1045 36.7472 27.7649C37.495 27.4254 38.3042 27.2417 39.1254 27.225C39.9477 27.1999 40.7661 27.3471 41.5282 27.6571C42.2902 27.9671 42.979 28.433 43.5504 29.025L50.6254 36.125ZM50.6254 15.025V30.8L46.1754 26.35C45.2612 25.4218 44.1715 24.6847 42.9698 24.1815C41.768 23.6784 40.4782 23.4192 39.1754 23.4192C37.8725 23.4192 36.5827 23.6784 35.381 24.1815C34.1792 24.6847 33.0896 25.4218 32.1754 26.35L31.9254 26.625L26.9254 32.075C26.2334 32.8268 25.2725 33.2748 24.2518 33.3217C23.2311 33.3685 22.2333 33.0103 21.4754 32.325C19.7566 30.8242 17.5691 29.9685 15.2882 29.9046C13.0074 29.8408 10.7754 30.5728 8.97537 31.975L0.500368 38.6C0.260617 37.4159 0.168249 36.2067 0.225368 35V15C0.225018 11.0562 1.77789 7.27085 4.54782 4.46349C7.31776 1.65612 11.0819 0.0525845 15.0254 0H35.8004C39.7482 0.0460613 43.5187 1.64673 46.294 4.45479C49.0693 7.26286 50.6256 11.0519 50.6254 15V15.025ZM19.7754 15.275C19.7754 14.2861 19.4821 13.3194 18.9327 12.4971C18.3833 11.6749 17.6024 11.034 16.6888 10.6556C15.7752 10.2772 14.7698 10.1781 13.7999 10.3711C12.83 10.564 11.9391 11.0402 11.2398 11.7395C10.5406 12.4387 10.0644 13.3296 9.87144 14.2995C9.67852 15.2695 9.77753 16.2748 10.156 17.1884C10.5344 18.102 11.1753 18.8829 11.9975 19.4324C12.8198 19.9818 13.7865 20.275 14.7754 20.275C16.1014 20.275 17.3732 19.7482 18.3109 18.8105C19.2486 17.8729 19.7754 16.6011 19.7754 15.275Z" fill="#C5C1B9" />
                                            </svg>
                                            <p className="gray_scale_3 font_size_20 font_weight_600">Upload Photo</p>
                                        </div>
                                    }
                                </div>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                    accept="image/*"
                                />
                            </div>


                            <div className="create_meal_modal_general_detail">
                                <div>
                                    <h4 className='font_family_ovo no_margin black'>Ingredients</h4>
                                    <div className="component_heading_separating_line"></div>
                                    <div>
                                        {ingredients.map((ingredient, i) => (
                                            <div key={i} className="create_meal_modal_ingredient_list_div">
                                                <div className="create_meal_modal_ingredien_div">
                                                    <p>Name</p>
                                                    <input className="create_meal_modal_meal_name" required value={ingredient.name ? ingredient.name : (typeof (ingredient) == 'string' ? ingredient : '')} onChange={(e) => ingredientFunc(e.target.value, i)} />
                                                    <div
                                                        ref={el => suggestionDivRefs.current[i] = el} // Assign each suggestion div its own ref
                                                        onClick={(e) => e.stopPropagation()}
                                                        className="create_meal_modal_ingredient_suggestion_div">
                                                        {ingredientSearchIndex === i ? ingredientSuggestion.map((ingred_sugg, j) => (
                                                            <p key={j} onClick={() => ingredSuggestionClicked(ingred_sugg, i)}
                                                                className={(j < ingredientSuggestion.length - 1 ? 'create_meal_modal_ingredient_suggestion_line' : '') +
                                                                    " create_meal_modal_ingredient_suggestion_p cursor_pointer"}>
                                                                {ingred_sugg.name}
                                                            </p>
                                                        )) : null}
                                                    </div>
                                                </div>
                                                <div>
                                                    <p>Unit</p>
                                                    <select className="create_meal_modal_meal_unit" onChange={(e) => unitSelected(e.target.value, i)}>
                                                        {ingredient?.units?.map((unit, i) => (
                                                            <option value={unit.ingredient_id} key={i} selected={unit.selected}>{unit.unit}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div>
                                                    <p>Amount</p>
                                                    <input className="create_meal_modal_meal_name"
                                                        value={ingredient.amount ? ingredient.amount : ''} step="any"
                                                        min={0} required onChange={(e) => ingredAmountFunc(e.target.value, i)} type='number' />
                                                </div>
                                                <div>
                                                    <p>Del</p>
                                                    <div onClick={() => { if (ingredients.length > 1) deleteIngredient(i) }} className={(ingredients.length > 1 ? 'cursor_pointer' : '') + " create_meal_modal_meal_ingredient_delete flex align_center justify_center"} >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 18 18" fill="none">
                                                            <path d="M14.2872 5.39984H3.70353C3.56573 5.39696 3.42885 5.4229 3.30166 5.47597C3.17446 5.52905 3.05975 5.6081 2.96486 5.70807C2.86998 5.80804 2.79701 5.92672 2.75064 6.05651C2.70427 6.1863 2.68551 6.32434 2.69556 6.4618L3.33454 15.8575C3.37601 16.4479 3.6431 16.9997 4.08042 17.3985C4.51775 17.7973 5.09176 18.0125 5.68347 17.9994L12.4783 17.9184C13.0618 17.9102 13.6205 17.6808 14.0415 17.2765C14.4625 16.8722 14.7143 16.3233 14.7462 15.7405L15.2952 6.4528C15.3039 6.31607 15.2842 6.17901 15.2372 6.05029C15.1903 5.92158 15.1171 5.80401 15.0223 5.70504C14.9276 5.60606 14.8133 5.52783 14.6868 5.4753C14.5603 5.42276 14.4242 5.39707 14.2872 5.39984ZM10.3003 13.7696H7.69041C7.51139 13.7696 7.33971 13.6985 7.21312 13.5719C7.08654 13.4453 7.01543 13.2736 7.01543 13.0946C7.01543 12.9156 7.08654 12.7439 7.21312 12.6173C7.33971 12.4907 7.51139 12.4196 7.69041 12.4196H10.3003C10.4793 12.4196 10.651 12.4907 10.7776 12.6173C10.9042 12.7439 10.9753 12.9156 10.9753 13.0946C10.9753 13.2736 10.9042 13.4453 10.7776 13.5719C10.651 13.6985 10.4793 13.7696 10.3003 13.7696ZM11.0023 10.4397H6.98843C6.80941 10.4397 6.63773 10.3686 6.51115 10.242C6.38456 10.1154 6.31345 9.94372 6.31345 9.7647C6.31345 9.58569 6.38456 9.414 6.51115 9.28742C6.63773 9.16084 6.80941 9.08972 6.98843 9.08972H11.0023C11.1813 9.08972 11.353 9.16084 11.4796 9.28742C11.6062 9.414 11.6773 9.58569 11.6773 9.7647C11.6773 9.94372 11.6062 10.1154 11.4796 10.242C11.353 10.3686 11.1813 10.4397 11.0023 10.4397ZM17.0951 4.06788C17.0684 4.24431 16.973 4.403 16.8296 4.50924C16.6863 4.61549 16.5067 4.66066 16.3301 4.63486C11.4722 3.96666 6.54557 3.96666 1.68759 4.63486H1.5706C1.40128 4.6344 1.23832 4.57032 1.11404 4.45533C0.989759 4.34034 0.913233 4.18284 0.899641 4.01407C0.886048 3.8453 0.936382 3.67758 1.04066 3.54419C1.14494 3.41079 1.29554 3.32146 1.4626 3.2939C1.5886 3.2939 3.10955 3.03291 5.46748 2.87992L5.76447 1.35896C5.83972 0.975387 6.04614 0.629966 6.3483 0.381994C6.65047 0.134022 7.02953 -0.00103464 7.42041 5.96874e-06H10.5973C10.9903 0.00149751 11.3705 0.139736 11.6727 0.390993C11.9748 0.642249 12.1801 0.990852 12.2533 1.37696L12.5323 2.88892C13.8102 2.96991 15.1512 3.09591 16.5191 3.3029C16.6073 3.31505 16.6922 3.3445 16.7689 3.38958C16.8457 3.43466 16.9127 3.49447 16.9663 3.56557C17.0198 3.63667 17.0587 3.71765 17.0809 3.80386C17.103 3.89006 17.1078 3.97979 17.0951 4.06788Z" fill="#FF234E" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="create_meal_modal_meal_ingredient_add gray_gradient flex align_center justify_center gap_8 cursor_pointer" onClick={addNewIngredient}>
                                        <FaPlus size={18} />
                                        <p className="green_gradient_p font_weight_600">Add</p>
                                    </div>
                                </div>


                                <div>
                                    <h4 className='font_family_ovo no_margin black'>Recipe</h4>
                                    <div className="component_heading_separating_line"></div>
                                    <div>
                                        {recipes && recipes.map((recipe, i) => (
                                            <div key={i} className="create_meal_modal_recipe_list_div">
                                                <div>
                                                    <p>Steps</p>
                                                    <p className="create_meal_modal_recipe_step">{i + 1}.</p>
                                                </div>
                                                <div>
                                                    <p>Description</p>
                                                    <input className="create_meal_modal_meal_name" value={recipe} onChange={(e) => recipeFunc(e.target.value, i)} />
                                                </div>
                                                <div>
                                                    <p>Del</p>
                                                    <div onClick={() => { if (recipes.length > 1) deleteRecipe(i) }} className={(recipes.length > 1 ? 'cursor_pointer' : '') + " create_meal_modal_meal_ingredient_delete flex align_center justify_center"} >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 18 18" fill="none">
                                                            <path d="M14.2872 5.39984H3.70353C3.56573 5.39696 3.42885 5.4229 3.30166 5.47597C3.17446 5.52905 3.05975 5.6081 2.96486 5.70807C2.86998 5.80804 2.79701 5.92672 2.75064 6.05651C2.70427 6.1863 2.68551 6.32434 2.69556 6.4618L3.33454 15.8575C3.37601 16.4479 3.6431 16.9997 4.08042 17.3985C4.51775 17.7973 5.09176 18.0125 5.68347 17.9994L12.4783 17.9184C13.0618 17.9102 13.6205 17.6808 14.0415 17.2765C14.4625 16.8722 14.7143 16.3233 14.7462 15.7405L15.2952 6.4528C15.3039 6.31607 15.2842 6.17901 15.2372 6.05029C15.1903 5.92158 15.1171 5.80401 15.0223 5.70504C14.9276 5.60606 14.8133 5.52783 14.6868 5.4753C14.5603 5.42276 14.4242 5.39707 14.2872 5.39984ZM10.3003 13.7696H7.69041C7.51139 13.7696 7.33971 13.6985 7.21312 13.5719C7.08654 13.4453 7.01543 13.2736 7.01543 13.0946C7.01543 12.9156 7.08654 12.7439 7.21312 12.6173C7.33971 12.4907 7.51139 12.4196 7.69041 12.4196H10.3003C10.4793 12.4196 10.651 12.4907 10.7776 12.6173C10.9042 12.7439 10.9753 12.9156 10.9753 13.0946C10.9753 13.2736 10.9042 13.4453 10.7776 13.5719C10.651 13.6985 10.4793 13.7696 10.3003 13.7696ZM11.0023 10.4397H6.98843C6.80941 10.4397 6.63773 10.3686 6.51115 10.242C6.38456 10.1154 6.31345 9.94372 6.31345 9.7647C6.31345 9.58569 6.38456 9.414 6.51115 9.28742C6.63773 9.16084 6.80941 9.08972 6.98843 9.08972H11.0023C11.1813 9.08972 11.353 9.16084 11.4796 9.28742C11.6062 9.414 11.6773 9.58569 11.6773 9.7647C11.6773 9.94372 11.6062 10.1154 11.4796 10.242C11.353 10.3686 11.1813 10.4397 11.0023 10.4397ZM17.0951 4.06788C17.0684 4.24431 16.973 4.403 16.8296 4.50924C16.6863 4.61549 16.5067 4.66066 16.3301 4.63486C11.4722 3.96666 6.54557 3.96666 1.68759 4.63486H1.5706C1.40128 4.6344 1.23832 4.57032 1.11404 4.45533C0.989759 4.34034 0.913233 4.18284 0.899641 4.01407C0.886048 3.8453 0.936382 3.67758 1.04066 3.54419C1.14494 3.41079 1.29554 3.32146 1.4626 3.2939C1.5886 3.2939 3.10955 3.03291 5.46748 2.87992L5.76447 1.35896C5.83972 0.975387 6.04614 0.629966 6.3483 0.381994C6.65047 0.134022 7.02953 -0.00103464 7.42041 5.96874e-06H10.5973C10.9903 0.00149751 11.3705 0.139736 11.6727 0.390993C11.9748 0.642249 12.1801 0.990852 12.2533 1.37696L12.5323 2.88892C13.8102 2.96991 15.1512 3.09591 16.5191 3.3029C16.6073 3.31505 16.6922 3.3445 16.7689 3.38958C16.8457 3.43466 16.9127 3.49447 16.9663 3.56557C17.0198 3.63667 17.0587 3.71765 17.0809 3.80386C17.103 3.89006 17.1078 3.97979 17.0951 4.06788Z" fill="#FF234E" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="create_meal_modal_meal_ingredient_add gray_gradient flex align_center justify_center gap_8 cursor_pointer" onClick={addNewRecipe}>
                                        <FaPlus size={18} />
                                        <p className="green_gradient_p font_weight_600">Add</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div >
            </FullScreenOverlay >
        </div>
    );
}


export default EditMealModal;